// extracted by mini-css-extract-plugin
export var container = "_8k-0";
export var error = "_8k-9";
export var label = "_8k-5";
export var light = "_8k-6";
export var md = "_8k-3";
export var sm = "_8k-2";
export var thin = "_8k-8";
export var thinBold = "_8k-7";
export var vertical = "_8k-4";
export var xs = "_8k-1";